import dynamic from "next/dynamic";
import HubspotSideBySideFormConfig from "./hubspot-side-by-side-form-config";
import HubspotSideBySideFormAdvancedConfig from "./hubspot-side-by-side-form-advanced-config";
const HubspotSideBySideFormComponent = dynamic(()=>import("./hubspot-side-by-side-form-component"));
export default {
    HubspotSideBySideFormComponent,
    HubspotSideBySideFormConfig,
    HubspotSideBySideFormAdvancedConfig
};
